<button
  #element
  class="btn btn-primary cx-customer-ticketing-create"
  (click)="openCreateNewTicketDialog()"
>
  {{ 'createCustomerTicket.addRequest' | cxTranslate }}
</button>